
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.minusButton = this.querySelector('[name="minus"]');
      this.plusButton = this.querySelector('[name="plus"]');
    }

    connectedCallback() {
      if (!this.input) return;

      this.minusButton?.addEventListener('click', this.onButtonClick.bind(this, -1));
      this.plusButton?.addEventListener('click', this.onButtonClick.bind(this, 1));
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.input.addEventListener('input', this.onInputChange.bind(this));

      // Validate initial state
      this.validateQuantity();
    }

    onButtonClick(change, event) {
      event.preventDefault();

      const previousValue = parseInt(this.input.value) || 1;
      const step = parseInt(this.input.step) || 1;
      const newValue = previousValue + (change * step);

      this.input.value = newValue;
      this.validateQuantity();

      // Dispatch change event for form handling
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onInputChange() {
      this.validateQuantity();
    }

    validateQuantity() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      const step = parseInt(this.input.step) || 1;

      // Clamp value to valid range
      let validValue = Math.max(min, Math.min(max, value));

      // Ensure value respects step
      if ((validValue - min) % step !== 0) {
        validValue = min + Math.floor((validValue - min) / step) * step;
      }

      if (validValue !== value) {
        this.input.value = validValue;
      }

      // Update button states
      this.updateButtonStates(validValue, min, max);
    }

    updateButtonStates(value, min, max) {
      if (this.minusButton) {
        this.minusButton.disabled = value <= min;
        this.minusButton.classList.toggle('quantity__button--disabled', value <= min);
      }

      if (this.plusButton) {
        this.plusButton.disabled = value >= max;
        this.plusButton.classList.toggle('quantity__button--disabled', value >= max);
      }
    }

        setQuantity(quantity) {
      this.input.value = quantity;
      this.validateQuantity();
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

        getQuantity() {
      return parseInt(this.input.value) || 1;
    }
  });
}
